var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('nd'),_c('ab'),_c('v-main',[_c('v-container',{staticClass:"pa-5 offset-12 col-md-8 col-lg-6",attrs:{"fluid":""}},[_c('router-view')],1)],1),(_vm.$vuetify.breakpoint.smAndUp)?_c('ftr'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }